import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService} from '../../shared';
import {Core2Config} from '../../shared';
import {ClaimOcrScannedDocContainerModel} from '../../../../../../models';
import {Observable} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ClaimOcrScannedDocService extends BaseApiTemplateService<ClaimOcrScannedDocContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
    Core2Config.CLAIMS_PREFIX + 'scanned-docs/upload-file/login-entity-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'scanned-docs/upload-file/login-entity-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'scanned-docs/upload-file/login-entity-ep';
    this.httpClient = http;
  }

  getOcrImage(guid: string, visa: ApiVisa): Observable<Blob> {
    let url = Core2Config.DOMAIN_URL +  'core2/tnt/dm/erp/aat/claims/scanned-docs/image-file/backoffice-ep/' + guid;
    if (visa.api_domain_url) {
      url = visa.api_domain_url +  'core2/tnt/dm/erp/aat/claims/scanned-docs/image-file/backoffice-ep/' + guid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(visa));
  }

  uploadTngStatement(dtoObject: FormData, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let uploadUrl = "";
    if (visa.api_domain_url) {
      uploadUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'scanned-docs/upload-statements/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      uploadUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

}


